'use client';

import React from 'react';
import { Box, HStack, Text, VStack } from '@skin-seoul/design-system';
import LucideIcon from '@/components/ui/LucideIcon';
interface StarIngredientItemProps {
  name: string;
  efficacy: string;
  efficacyDescription: string;
  isExpanded?: boolean;
  onToggle?: () => void;
  isInModal?: boolean;
}
const StarIngredientItem = ({
  name,
  efficacy,
  efficacyDescription,
  isExpanded = false,
  onToggle,
  isInModal = false
}: StarIngredientItemProps) => {
  const hasDescription = Boolean(efficacyDescription);
  return <Box background="neutral.50" borderRadius="8px" width="100%" padding={4} data-sentry-element="Box" data-sentry-component="StarIngredientItem" data-sentry-source-file="StarIngredientItem.tsx">
      <VStack gap={3} alignItems="stretch" width="100%" data-sentry-element="VStack" data-sentry-source-file="StarIngredientItem.tsx">
        {/* Header */}
        <HStack gap={3} alignItems="center" justifyContent="space-between" width="100%" onClick={onToggle} cursor="pointer" data-sentry-element="HStack" data-sentry-source-file="StarIngredientItem.tsx">
          <HStack gap={3} alignItems="center" justifyContent="space-between" flex={1} data-sentry-element="HStack" data-sentry-source-file="StarIngredientItem.tsx">
            <Text textStyle={{
            base: 'label.medium',
            tablet: 'label.large'
          }} fontWeight="medium" color="neutral.500" textAlign="left" truncate height="20px" maxWidth={{
            base: '180px',
            tablet: isInModal ? '360px' : '100%'
          }} data-sentry-element="Text" data-sentry-source-file="StarIngredientItem.tsx">
              {name}
            </Text>
            <Text textStyle="label.small" fontWeight="medium" color="primary.400" textAlign="left" whiteSpace="nowrap" data-sentry-element="Text" data-sentry-source-file="StarIngredientItem.tsx">
              {efficacy}
            </Text>
          </HStack>
          {hasDescription && <Box cursor="pointer">
              <LucideIcon name={isExpanded ? 'CircleMinus' : 'CirclePlus'} size="md" color="primary.400" strokeWidth={1} />
            </Box>}
        </HStack>

        {/* Divider */}
        {isExpanded && hasDescription && <Box height="1px" width="100%" background="neutral.100" marginY={0} />}

        {/* Description */}
        {isExpanded && hasDescription && <Text textStyle={{
        base: 'paragraph.small',
        tablet: 'paragraph.medium'
      }} fontWeight="normal" color="neutral.600" textAlign="left">
            {efficacyDescription}
          </Text>}
      </VStack>
    </Box>;
};
export default StarIngredientItem;